import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModalShellComponent } from '@infrastructure/ui/components/modals/modal-shell/modal-shell.component';
import { ConfirmacaoSimNaoComponent } from '@infrastructure/ui/components/modals/confirmacao-sim-nao/confirmacao-sim-nao.component';
import { TabsComponent } from '@infrastructure/ui/components/tabs/tabs.component';
import { TabPanelComponent } from '@infrastructure/ui/components/tabs/tab-panel.component';
import { FormFooterComponent } from '@infrastructure/ui/components/forms/form-footer/form-footer.component';
import { PrototypeSelectComponent } from '@infrastructure/ui/components/forms/prototype-select/prototype-select.component';
import { PeriodoSelectComponent } from '@infrastructure/ui/components/forms/periodo-select/periodo-select.component';
import { AnexosComponent } from '@infrastructure/ui/components/anexos/anexos.component';
import { PageTitleModule } from '@infrastructure/ui/components/page-title/page-title.module';
import { UtilsComponentesModule } from '../../../utils/componentes/utils-componentes.module';
import { DatepickerComponent } from '@infrastructure/ui/components/forms/datepicker/datepicker.component';
import { InstrumentoAvaliacaoModalModule } from '../../instrumentos-avaliacao/components/instrumento-avaliacao-modal.module';
import { SituacaoFilterDropdownComponent } from '@infrastructure/ui/components/forms/situacao-filter-dropdown/situacao-filter-dropdown.component';
import { LucideAngularModule } from 'lucide-angular';
import {
  X,
  ChevronDown,
  ChevronUp,
  Calendar,
  CalendarDays,
  Search,
  List,
  Calculator,
  Eye,
  EyeOff,
  RefreshCw,
  Undo,
  ArrowLeftCircle,
  ArrowRightCircle,
  Loader2,
  AlertTriangle,
  Users,
  ClipboardList,
  ClipboardCheck,
  MessageSquare,
  Star,
  Info,
  CalendarX,
  Lock,
  Trash2,
  Plus,
  ArrowDownAZ,
  ArrowUpZA,
  ArrowDown01,
  ArrowDown10,
  Target,
  Paperclip,
  Earth,
  Check,
  Edit2,
  NotebookPen,
  GraduationCap,
  Download,
  FileText,
  Image,
  LockOpen
} from 'lucide-angular';
import { SharedModule } from '../../../shared/shared.module';

import { DesempenhoEscolarComponent } from './desempenho-escolar.component';
import { DesempenhoInstrumentoComponent } from './desempenho-instrumento.component';
import { DesempenhoAnoComponent } from './desempenho-ano.component';
import { InputNotaComponent } from './input-nota.component';
import { PublicacaoAnualModalComponent } from './publicacao-anual-modal.component';
import { DataExamesConselhoModalComponent } from './data-exames-conselho-modal.component';
import { ParecerModalComponent } from './parecer-modal.component';
import { AvaliacaoDescritivaModalComponent } from './avaliacao-descritiva-modal.component';

// InputParecer/InputCha/InputObjetivoAprendizagem/AnexoDesempenho existem mas não
// são usados nos templates atuais — não declarados/exportados aqui.

@NgModule({
  declarations: [
    DesempenhoEscolarComponent,
    DesempenhoInstrumentoComponent,
    DesempenhoAnoComponent,
    InputNotaComponent,
    PublicacaoAnualModalComponent,
    DataExamesConselhoModalComponent,
    ParecerModalComponent,
    AvaliacaoDescritivaModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    ModalShellComponent,
    ConfirmacaoSimNaoComponent,
    TabsComponent,
    TabPanelComponent,
    FormFooterComponent,
    PrototypeSelectComponent,
    PeriodoSelectComponent,
    PageTitleModule,
    AnexosComponent,
    DatepickerComponent,
    UtilsComponentesModule,
    InstrumentoAvaliacaoModalModule,
    SituacaoFilterDropdownComponent,
    LucideAngularModule.pick({
      X,
      ChevronDown,
      ChevronUp,
      Calendar,
      CalendarDays,
      Search,
      List,
      Calculator,
      Eye,
      EyeOff,
      RefreshCw,
      Undo,
      ArrowLeftCircle,
      ArrowRightCircle,
      Loader2,
      AlertTriangle,
      Users,
      ClipboardList,
      ClipboardCheck,
      MessageSquare,
      Star,
      Info,
      CalendarX,
      Lock,
      Trash2,
      Plus,
      ArrowDownAZ,
      ArrowUpZA,
      ArrowDown01,
      ArrowDown10,
      Target,
      Paperclip,
      Earth,
      Check,
      Edit2,
      NotebookPen,
      GraduationCap,
      Download,
      FileText,
      Image,
      LockOpen
    })
  ],
  exports: [
    DesempenhoEscolarComponent,
    DesempenhoInstrumentoComponent,
    DesempenhoAnoComponent,
    InputNotaComponent,
    PublicacaoAnualModalComponent,
    DataExamesConselhoModalComponent,
    ParecerModalComponent,
    AvaliacaoDescritivaModalComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class DesempenhoEscolarModule { }